import type { SVGProps } from "react";

export default function PaperclipIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.59694 14.8383L13.1727 8.54393C13.9622 7.78825 13.9622 6.56299 13.1727 5.80727C12.3832 5.05156 11.1032 5.05156 10.3137 5.80727L3.78558 12.0561C2.28554 13.4919 2.28554 15.8199 3.78558 17.2558C5.28562 18.6917 7.71767 18.6917 9.21769 17.2558L15.8411 10.9158C18.0517 8.79976 18.0517 5.36903 15.8411 3.25302C13.6305 1.13701 10.0464 1.13701 7.83585 3.25302L2.49902 8.36151"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
